var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton as MuiIconButton } from '@mui/material';
import { StringUtils } from '../../utils';
export var IconButton = function (props) { return (_jsx(MuiIconButton, __assign({ className: StringUtils.combineStrings(['localina-iconbutton', props.className]), disabled: props.disabled, disableRipple: true, onClick: props.onClick, component: props.component, "aria-label": props.ariaLabel }, { children: props.icon }))); };
